/**
 * The longest single template tag or HTML element any grammar here will match.
 *
 * Every pattern that scans forward for a closing delimiter must bound that scan.
 * Unbounded, an opening delimiter whose close never arrives — a typo, a
 * truncated paste, LLM-authored HTML — makes each start position rescan to the
 * end of the input, which is quadratic overall: 640 KB of `{% if a ` took 16
 * seconds on the request thread before this bound existed.
 *
 * The bound goes in a lookahead so a tag with no close nearby fails in
 * O(MAX_TAG_LENGTH) rather than O(input). Tradeoff: a tag or element longer than
 * this is not matched at all. Real markup is nowhere near it — the longest
 * plausible tag body is an `{% if %}` condition or an `{% include %}` argument
 * list, both well under 1 KB.
 */
export const MAX_TAG_LENGTH = 4096;
